import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { UserCog, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const { impersonating, user, stopImpersonation } = useAuth();
  if (!impersonating || !user || user.role !== "applicant") return null;

  const exit = async () => {
    await stopImpersonation();
    navigate("/admin");
  };

  return (
    <div className="relative z-50 bg-amber-500 text-amber-950 print:hidden" data-testid="impersonation-banner">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm font-medium">
          <UserCog className="w-4 h-4 shrink-0" />
          <span>
            Estás creando una solicitud en nombre de <strong>{user.name || user.rut}</strong>
            {user.rut ? <> · {user.rut}</> : null}
          </span>
        </div>
        <Button size="sm" variant="outline"
          className="h-8 rounded-lg bg-white/90 border-amber-700 text-amber-900 hover:bg-white"
          onClick={exit} data-testid="btn-exit-impersonation">
          <LogOut className="w-4 h-4 mr-1" /> Volver al panel de admin
        </Button>
      </div>
    </div>
  );
}
